module.exports = __webpack_public_path__ + "img/ydzrbf1.9bf1d756.png";